<template>
  <Card shadow>
    <Row type="flex" justify="center">
      <div class="face-data-img-box">
        <img :src="head_url" alt=""/>
      </div>
    </Row>
    <Row type="flex" justify="center">
      <h3><strong v-if="me.company">公司ID:{{ me.company.pid == 0 ? me.current_company : me.company.pid }}</strong></h3>
    </Row>
    <Row type="flex" justify="center">
      <h3><strong>{{ me.realname }}</strong></h3>
    </Row>
    <Row type="flex" justify="center">
      <h4><strong>{{ me.username }}</strong></h4>
    </Row>
    <Row>
      <Col span="24">
        <div class="login-info-div">
          <Icon size="26" type="ios-contact"/>
          <span>{{ $t('l.job_num') }}：{{ me.job_num || $t('l.no_data') }}</span>
        </div>
      </Col>
      <Col span="24">
        <div class="login-info-div">
          <Icon size="26" type="ios-folder-open"/>
          <span>{{ $t('l.position') }}：{{ me.job || $t('l.no_data') }}</span>
        </div>
      </Col>
      <Col span="24">
        <div class="login-info-div">
          <Icon size="26" type="ios-call"/>
          <span>{{ $t('l.phone_no') }}：{{ me.mobile || $t('l.no_data') }}</span>
        </div>
      </Col>
      <Col span="24">
        <div class="login-info-div">
          <Icon size="26" type="ios-at"/>
          <span>{{ $t('l.e_mail') }}：{{ me.email || $t('l.no_data') }}</span>
        </div>
      </Col>
      <!-- 上传公司logo -->
      <template v-if="!$store.state.app.isMobile">
        <Col span="24">
          <Upload :action="uploadAddress" :data="{token:me.token,cid:me.current_company}" :on-success="uploadSuccess">
            <Button type="primary" icon="ios-cloud-upload-outline">{{ $t('l.company_logo') }}</Button>
          </Upload>
          <span class="remark192">{{ $t("l.remark192") }}</span>
        </Col>
      </template>
      <Divider></Divider>
    </Row>
    <Row class="login-info-depart">
      <Col>
        <h3>{{ $t('l.company') }}/{{ $t('l.department') }} {{ $t('l.select') }}</h3>
        <div class="login-info-depart-div">
          <Tag v-for="(depart,index) in departNames"
               :key="index"
               size="large"
               @click.native="onDepartSelect(depart)"
               :color="me.current_company==depart.id?'blue':'default'">{{ depart.depart }}
          </Tag>
        </div>
      </Col>
      <Divider></Divider>
    </Row>
    <Row>
      <Col>
        <Button long @click="modal.show = true">{{ $t('l.change_pwd') }}</Button>
        <Button class="margin-top-10 margin-bottom-10" type="primary" @click="logout" long>{{ $t('l.log_out') }}
        </Button>
        <Button v-if="$store.state.user.isROOT" type="dashed" long @click="flushServerCache">{{ $t('l.wipe_cache') }}
        </Button>
      </Col>
    </Row>
    <template>
      <lg-modal :show="modal.show" :title="modal.title" @on-submit="submit('modal')" @on-cancel="modal.show=false">
        <Form ref="modal" :model="modal" :rules="getRules">
          <FormItem prop="user.oldPassword" :label="$t('l.pwd_old')">
            <Input :type="passwordType" v-model="modal.user.oldPassword" :placeholder="$t('l.remark7')">
                      <span @click="changeShowPwd" slot="suffix">
                        <template v-if="showPwdContent">
                              <Icon type="ios-eye"/>
                        </template>
                        <template v-else>
                              <Icon type="ios-eye-off"/>
                        </template>
                    </span>
            </Input>
          </FormItem>
          <FormItem prop="user.newPassword" :label="$t('l.pwd_new')">
            <Input :type="passwordType" v-model="modal.user.newPassword" :placeholder="$t('l.remark5')">
                        <span @click="changeShowPwd" slot="suffix">
                        <template v-if="showPwdContent">
                              <Icon type="ios-eye"/>
                        </template>
                        <template v-else>
                              <Icon type="ios-eye-off"/>
                        </template>
                    </span>
            </Input>
          </FormItem>
          <FormItem prop="user.confirmNewPassword" :label="$t('l.confirm_new_pwd')">
            <Input :type="passwordType" v-model="modal.user.confirmNewPassword" :placeholder="$t('l.remark6')">
                                      <span @click="changeShowPwd" slot="suffix">
                        <template v-if="showPwdContent">
                              <Icon type="ios-eye"/>
                        </template>
                        <template v-else>
                              <Icon type="ios-eye-off"/>
                        </template>
                    </span>
            </Input>
          </FormItem>
        </Form>
      </lg-modal>
    </template>
  </Card>
</template>

<script>
import util from '@/libs/util';
import lgModal from '../my-components/lg-modal'
import { validatePass } from "@/common/validate";
export default {
  name: "login-info",
  components: {
    lgModal
  },
  data() {
    return {
      modal: {
        show: false,
        title: this.$t('l.change_pwd'),
        user: {
          oldPassword: '',
          newPassword: '',
          confirmNewPassword: ""
        },
      },
      uploadAddress: util.baseURL + 'portal/upload_logo',
      showPwdContent:false,
      passwordType:"password"
    }
  },
  computed: {
    getRules() {
      return {
        "user.oldPassword": [{required: true, message: this.$t('l.remark8'), trigger: 'blur'}],
        "user.newPassword": [{required: true, validator:validatePass, trigger: 'blur'}],
        "user.confirmNewPassword": [{required: true, validator:validatePass,trigger: 'blur'}]
      }
    },
    me() {
      return this.$store.state.user.user || {};
    },
    head_url() {
      if (this.$store.state.user.user && this.$store.state.user.user.head_url) return this.$store.state.user.user.head_url;
      return "https://static.diantiyun.com/upload/image/avatar.png";
    },
    companyMaps() {
      let map = {};
      if (this.me.companies) this.me.companies.forEach(comp => {
        map[comp.id.toString()] = comp;
      })
      return map;
    },
    departNames() {
      let result = [];
      if (!this.me.departs) return result;
      this.me.companies.map(depart => {
        if (this.companyMaps[depart.company_id.toString()])
          result.push({
            company: this.companyMaps[depart.company_id.toString()].name,
            depart: depart.name,
            company_id: depart.company_id,
            id: depart.id
          });
      })
      return result;
    }
  },
  methods: {
    changeShowPwd(){
      this.showPwdContent = !this.showPwdContent;
      this.passwordType = this.showPwdContent ?"text":"password";
    },
    uploadSuccess(res, file) {
      if (!res.code) {
        this.$store.commit('setUserCompanyLogo', res.data.logo);
      }
    },
    setTreeMap(tree, map) {
      tree.forEach(node => {
        map[node.id.toString()] = node;
        if (node.children) this.setTreeMap(node.children, map);
      })
    },
    onDepartSelect(depart) {
      if (this.me.current_company == depart.id) return;
      util.setCompany(depart.id).then(() => {
        location.reload()
      })
    },
    submit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if(this.modal.user.confirmNewPassword != this.modal.user.newPassword){
            this.$Message.error(this.$t('l.remark14_c'));
            return
          }
          util.ajax.post("/user/updatepwd", {
            oldPassword: this.modal.user.oldPassword,
            newPassword: this.modal.user.newPassword
          }).then(res => {
            if (!res.code) {
              this.$Message.success(this.$t('l.remark166'));
              this.$router.push({path: '/login'})
            }
          })
        }
      })
    },
    flushServerCache() {
      util.ajax.get('/flushcache').then(res => {
        this.$Message.success(this.$t('l.remark167'))
      })
    },
    logout() {//    注销
      this.$router.replace({path: '/login'});
      window.location.reload(true);
      localStorage.removeItem("token");
      this.$store.commit('setIndex');
    }
  }
}
</script>

<style scoped lang="less">
/*.cell >>> .ivu-cell-title {*/
/*display: inline-block;*/
/*width: 220px;*/
/*text-overflow: ellipsis;*/
/*overflow: hidden*/
/*}*/
/*.cell >>> .ivu-cell-label{*/
/*width: 215px;*/
/*text-overflow: ellipsis;*/
/*overflow: hidden*/
/*}*/
::-webkit-scrollbar {
  display: none;
}

/*.head-portrait{*/
/*width: 100px;*/
/*height: 100px;*/
/*border: 1px solid #0984e3;*/
/*border-radius: 50%;*/
/*margin-bottom: 20px;*/
/*background-repeat: no-repeat;*/
/*background-size: cover;*/
/*}*/
.login-info-div {
  margin: 5px 0;
  font-size: 16px;

  span {
    font-weight: 500;
    color: #515a6e;
    margin-left: 4px;
  }
}

.login-info-depart {
  &-div {
    max-height: 100px;
    overflow-y: auto;
    margin: 10px 0;
  }
}

.face-data-img-box {
  width: 80px;
  height: 80px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  border: 1px solid #1e90ff;
  display: flex;
  justify-content: center;
  align-content: center;
  background-repeat: round;
}

.face-data-img-box img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.remark192 {
  font-size: 12px;
  /*color: #b2bec3;*/
  color: #999;
}
</style>